import {ComponentType, PropsWithoutRef, Suspense, SuspenseProps, forwardRef} from "react";
import Loading from "../components/Loading";

export function withSuspense<T, P>(
  WrappedComponent: ComponentType<PropsWithoutRef<P>>,
  fallback?: SuspenseProps["fallback"],
) {
  fallback = fallback ?? <Loading m={8} />;
  return forwardRef<T, P>((props: PropsWithoutRef<P>, ref) => (
    <Suspense fallback={fallback}>
      <WrappedComponent ref={ref} {...props} />
    </Suspense>
  ));
}
